import { createReducer, on, Action } from '@ngrx/store';
import { ModuleConfig, ModuleId } from '@intellio/shared/models';

import * as ModuleConfigsActions from './module-configs.actions';

export const MODULE_CONFIGS_FEATURE_KEY = 'moduleConfigs';

export interface ModuleConfigsState {
  configs: Map<ModuleId, ModuleConfig[]>;
  loaded: Map<ModuleId, boolean>;
  loading: Map<ModuleId, boolean>;
  error?: any;
}

export interface ModuleConfigsPartialState {
  readonly [MODULE_CONFIGS_FEATURE_KEY]: ModuleConfigsState;
}

export const initialState: ModuleConfigsState = {
  configs: new Map<ModuleId, ModuleConfig[]>(),
  loaded: new Map<ModuleId, boolean>(),
  loading: new Map<ModuleId, boolean>(),
  error: null,
};

const moduleConfigsReducer = createReducer(
  initialState,
  on(ModuleConfigsActions.getModuleConfigs, (state, { moduleId }) => {
    const loading = new Map(state.loading);
    loading.set(moduleId, true);

    return {
      ...state,
      loading,
      error: null,
    };
  }),
  on(
    ModuleConfigsActions.getModuleConfigsSuccess,
    (state, { moduleId, configs }) => {
      const loading = new Map(state.loading);
      const loaded = new Map(state.loaded);
      const configMap = new Map(state.configs);

      loading.set(moduleId, false);
      loaded.set(moduleId, true);
      configMap.set(moduleId, configs);

      return {
        ...state,
        loading,
        loaded,
        configs: configMap,
        error: null,
      };
    }
  ),
  on(
    ModuleConfigsActions.getModuleConfigsFailure,
    (state, { moduleId, error }) => {
      const loading = new Map(state.loading);
      const loaded = new Map(state.loaded);

      loading.set(moduleId, false);
      loaded.set(moduleId, false);

      return {
        ...state,
        loading,
        loaded,
        error,
      };
    }
  )
);

export function reducer(
  state: ModuleConfigsState | undefined,
  action: Action
) {
  return moduleConfigsReducer(state, action);
}
